import { INavMenu } from "@layouts/components/nav.model";
import { ROLES } from '@shared/models/user';
import { uriConsts } from '@shared/constants';

/**
 * Trang trong menu Hệ thống mà tài khoản Admin (role hệ thống 2) được vào; Super Admin vào được tất cả.
 * NavService ẩn các mục còn lại, systemAdminGuard chặn vào thẳng bằng URL. Chỉ giới hạn ở FE.
 */
export const ADMIN_ALLOWED_SYSTEM_URLS: string[] = [
  uriConsts.sys.SYS_PAGES, // Danh sách pages
  uriConsts.sys.SYS_USERS, // Danh sách user
  uriConsts.sys.SYS_PAYMENT, // Danh sách giao dịch
  uriConsts.sys.SYS_AUDIT_LOG, // Nhật ký thao tác
  uriConsts.sys.SYS_REPORT_PAGE_CONVERSATION, // Báo cáo hội thoại
];

export const navItems: INavMenu[] = [
  {
    path: 'conversation',
    display: 1,
    role: ROLES.Business_Staff,
    permission: 'conversation',
    title: 'common.conversation', // Hội thoại
    icon: 'ph ph-chat-circle-dots',
    url: uriConsts.chat.CONVERSATION_INDEX
  },
  {
    path: 'feature',
    display: 1,
    role: ROLES.Business_Staff,
    title: 'common.feature',
    icon: 'ph ph-video-camera',
    children: [

      {
        path: '',
        display: 1,
        role: ROLES.Business_Staff,
        title: 'common.feature.introduction',
        icon: 'ph ph-gear',
        url: uriConsts.feature.INDEX
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Livestream',
        permission: 'live',
        icon: 'ph ph-video-camera',
        path: 'live',
        children: [
          {
            path: 'shopping',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'live.settings.forLive',
            permission: 'live_shopping',
            icon: 'ph ph-clipboard-text',
            url: uriConsts.live.LIVE_CHAT_SHOPPING_LIST,
          },
          {
            path: 'livestream',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.manageLivestream',
            permission: 'live_stream',
            icon: 'ph ph-video-camera',
            url: uriConsts.live.LIVE_CHAT_LIVESTREAM,
          },
          {
            path: 'printcomments',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.printComments',
            permission: 'live_print_comments',
            icon: 'ph ph-printer',
            url: uriConsts.live.LIVE_PRINT_COMMENTS,
          },
          {
            path: 'checkliveads/index',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.checkLiveAds',
            permission: 'live_checkliveads',
            icon: 'ph ph-check',
            url: uriConsts.live.LIVE_VIDEO_ADS,
          },
          {
            path: 'setting/index',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.generalSettingLivestream',
            permission: 'live_setting',
            icon: 'ph ph-gear',
            url: uriConsts.live.LIVE_CHAT_SETTING,
          },
        ]
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Chatbot',
        permission: 'chatbot',
        icon: 'ph ph-robot',
        path: 'chatbot',
        children: [
          {
            path: 'info',
            display: 1,
            role: ROLES.Business_Staff,
            originTitle: 'Chatbot Business Agent',
            permission: 'meta_biz_ai',
            icon: 'ph ph-robot',
            url: uriConsts.feature.METABIZ_INTRO,
          },
          {
            path: 'list',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.feature.chatbotScript',
            permission: 'chatbot_script',
            icon: 'ph ph-robot',
            url: uriConsts.feature.CHATBOT_LIST,
          },
          {
            path: 'genai',
            display: 1,
            role: ROLES.Business_Staff,
            originTitle: 'Chatbot AI',
            permission: 'chatbot_ai',
            icon: 'ph ph-robot',
            url: uriConsts.chatbot.CHATBOT_AI_ACCOUNT,
          },
        ]
      },
      {
        display: 1,
        role: ROLES.Business_Staff,
        path: 'chase',
        title: 'common.feature.chaseScenario',
        icon: 'ph ph-clock-counter-clockwise',
        permission: 'chatbot_automationcalender',
        url: uriConsts.feature.CHATBOT_AUTOMATIONCALENDER,

      },
      {
        display: 1,
        title: 'feature.title.bulkMessage',
        role: ROLES.Business_Staff,
        path: 'automationInbox',
        icon: 'ph ph-paper-plane-tilt',
        permission: 'chatbot_automationinbox',
        url: uriConsts.feature.CHATBOT_AUTOMATIONINBOX,
      },
      {
        display: 1,
        title: 'common.customAudience',
        path: 'audience',
        icon: 'ph ph-database',
        role: ROLES.Business_Staff,
        permission: 'chatbot_marketing',
        url: uriConsts.feature.CHATBOT_AUDIENCE,
      },
      {
        display: 1,
        title: 'common.message.marketing',
        icon: 'ph ph-megaphone',
        path: 'marketing',
        role: ROLES.Business_Staff,
        permission: 'chatbot_marketing',
        url: uriConsts.feature.CHATBOT_MARKETING,
      },
      {
        display: 1,
        title: 'common.message.utility',
        icon: 'ph ph-gear',
        path: 'utilityMessage',
        role: ROLES.Business_Staff,
        permission: 'chatbot_utilitymessage',
        url: uriConsts.feature.CHATBOT_UTILITYMESSAGE
      },
      // {
      // display: 0,
      // role: ROLES.Business_Staff,
      // title: 'Chatbot V2',
      // permission: 'chatbot',
      // isNewFeature: true,
      // path: '/feature/chatbot/list',
      // },
      {
        display: 1,
        role: ROLES.Business_Staff,
        icon: 'ph ph-clock-counter-clockwise',
        title: 'common.order.autoOrderCare',
        permission: 'chatbot_ecomcustomercare',
        path: 'ecomorderautomessage/index',
        url: uriConsts.feature.CHATBOT_ECOMCUSTOMERCARE
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Business Calling',
        permission: 'chatbot',
        icon: 'ph ph-phone',
        path: 'calling',
        children: [
          {
            path: 'checkstatus',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.feature.checkCallingStatus',
            permission: 'chatbot_script',
            icon: 'ph ph-check-circle',
            url: uriConsts.feature.CALLING_CHECK_STATUS,
          },
          {
            path: 'setting',
            display: 0,
            role: ROLES.Business_Staff,
            title: 'common.setting',
            permission: 'chatbot_ai',
            icon: 'ph ph-gear',
            url: uriConsts.feature.CALLING_SETTING,
          },
        ]
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Facebook Ads',
        permission: 'fbads',
        icon: 'ph ph-megaphone',
        path: 'ads',
        children: [
          {
            path: 'checkcontent',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.ads.checkContent',
            permission: 'checkContent',
            icon: 'ph ph-shield-check',
            url: uriConsts.ads.CHECK_CONTENT,
          },
        ]
      },
    ]
  },
  {
    path: 'order',
    display: 2,
    role: ROLES.Business_Staff,
    permission: 'order',
    title: 'common.order', // Đơn hàng
    icon: 'ph ph-shopping-bag',
    children: [
      {
        path: 'order',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'order_order',
        title: 'common.order',
        icon: 'ph ph-shopping-bag',
        url: uriConsts.order.ORDER_INDEX,
      },
      {
        path: 'draft',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'order_draft',
        title: 'common.order.draft', // đơn nháp
        icon: 'ph ph-notebook',
        url: uriConsts.order.ORDER_DRAFT,
      },
    ]
  },
  {
    path: 'customer',
    display: 1,
    role: ROLES.Page_Admin,
    permission: 'customer',
    title: 'common.customer', // khách hàng
    icon: 'ph ph-users',
    url: uriConsts.customer.CUSTOMER_INDEX
  },
  {
    path: 'setting',
    display: 1,
    role: ROLES.Business_Staff,
    permission: 'setting',
    title: 'common.setting', // cài đặt
    icon: 'ph ph-gear',
    url: uriConsts.settings.SETTING_INDEX,
    children: [
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
      {
        path: 'general',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_personalaccount',
        title: 'common.personalAccount', // cài đặt chung đối với tài khoản cá nhân
        icon: 'ph ph-user-gear',
        url: uriConsts.settings.SETTING_GENERAL
      },
      {
        path: 'conversation',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_conversation',
        title: 'common.conversation', // Hội thoại
        hasRoleRedirect: '/setting/general/index', // nếu k có quyền vào /conversation thì chuyển hướng về /general
        icon: 'ph ph-chat-circle-dots',
        url: uriConsts.settings.SETTING_CONVERSATION
      },
      {
        path: 'division',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_division',
        title: 'common.chat.splitConversation', // chia hội thoại
        icon: 'ph ph-chat-text',
        url: uriConsts.settings.SETTING_DIVISION
      },
      {
        path: 'tag',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_tag',
        title: 'common.chat.labelConversation', // nhãn hội thoại
        icon: 'ph ph-tag',
        url: uriConsts.settings.SETTING_TAG
      },
      {
        path: 'quickmsg',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_quickmsg',
        title: 'common.chat.instantMessaging', // tin nhắn nhanh
        icon: 'ph ph-envelope',
        url: uriConsts.settings.SETTING_QUICK_MSG
      },
      {
        path: 'ecomcustomercare',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_ecomcustomercare',
        title: 'common.order.autoOrderCare', // chăm sóc đơn hàng tự động
        icon: 'ph ph-robot',
        url: uriConsts.settings.SETTING_ECOM_CUSTOMER_CARE
      },
      {
        path: 'form',
        display: 0,
        role: ROLES.Business_Manager,
        originTitle: 'Form',
        icon: 'ph ph-notebook',
        url: uriConsts.settings.SETTING_FORM
      },
      {
        path: 'manageposts',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_manageposts',
        title: 'common.article', // Bài viết
        icon: 'ph ph-newspaper',
        url: uriConsts.settings.SETTING_MANAGE_POSTS
      },
      {
        path: 'managepage',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_managepage',
        title: 'common.listPages', //Quản lý pages
        icon: 'ph ph-calendar',
        url: uriConsts.settings.SETTING_MANAGE_PAGE
      },
      {
        path: 'user',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_user',
        title: 'common.staff', // nhân viên
        icon: 'ph ph-users',
        url: uriConsts.settings.SETTING_USER
      },
      {
        path: 'metasmc',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_metasmc',
        title: 'common.shopping.shoppingOnMes', // mua sắm trên Messenger
        icon: 'ph ph-messenger-logo',
        url: uriConsts.settings.SETTING_META_SM
      },
      {
        path: 'sendpurchase',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_sendpurchase',
        originTitle: 'Conversions API',
        icon: 'ph ph-arrows-left-right',
        url: uriConsts.settings.SETTING_SEND_PURCHASE
      },
      {
        path: 'affiliate',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_affiliate',
        title: 'common.marketing.affiliateMarketing', // tiếp thị liên kết
        icon: 'ph ph-users',
        url: uriConsts.settings.SETTING_AFFILIATE
      },
      {
        path: 'log',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_log',
        title: 'common.setting.history', // lịch sử cài đặt
        icon: 'ph ph-clock-counter-clockwise',
        url: uriConsts.settings.SETTING_LOG
      },
      {
        path: 'userlogs',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_log',
        title: 'setting.loginLogoutHistory',
        icon: 'ph ph-sign-in',
        url: uriConsts.settings.SETTING_USER_LOGS
      },
      {
        path: 'extension',
        display: 1,
        role: ROLES.Business_Staff,
        originTitle: 'Extension',
        icon: 'ph ph-file-code',
        url: uriConsts.settings.SETTING_EXTENSION
      },
    ]
  },
  {
    path: 'report',
    display: 2,
    role: ROLES.Page_Admin,
    permission: 'report',
    title: 'common.report', // báo cáo
    icon: 'ph ph-chart-line-up',
    children: [
      {
        path: 'dashboard',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_dashboard',
        title: 'common.dashboard', // tổng quan
        icon: 'ph ph-gauge',
        url: uriConsts.report.DASHBOARD_INDEX
      },
      {
        path: 'page',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_page',
        title: 'common.page', // trang
        icon: 'ph ph-flag',
        url: uriConsts.report.DASHBOARD_PAGE
      },
      {
        path: 'interactive',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_interactive',
        title: 'common.interact', // tương tác
        icon: 'ph ph-tree-structure',
        url: uriConsts.report.DASHBOARD_INTERACTIVE
      },
      {
        path: 'staff',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_staff',
        title: 'common.staff', // nhân viên
        icon: 'ph-fill ph-user-list',
        children: [
          {
            path: 'staff',
            display: 1,
            role: ROLES.Page_Admin,
            title: 'common.report.employee',
            permission: 'report_staff',
            icon: 'ph ph-chart-bar',
            url: uriConsts.report.DASHBOARD_STAFF
          },
          {
            path: 'activity',
            display: 1,
            role: ROLES.Business_Manager,
            title: 'common.activeTime',
            permission: 'report_staff',
            icon: 'ph-fill ph-user-list',
            url: uriConsts.report.DASHBOARD_ACTIVITY
          },
          {
            path: 'split',
            display: 1,
            role: ROLES.Business_Manager,
            title: 'common.conversation.splitHistory',
            permission: 'report_staff',
            icon: 'ph ph-arrow-elbow-right',
            url: uriConsts.report.SPLIT_INDEX
          }
        ]
      },
      {
        path: 'tag',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_tag',
        title: 'common.chat.labelConversation', // nhãn hội thoại
        icon: 'ph ph-tag',
        url: uriConsts.report.DASHBOARD_TAG
      },
      {
        path: 'tag2',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_tag',
        title: 'common.chat.labelConversation',
        icon: 'ph ph-tag',
        isNewFeature: true,
        url: uriConsts.report.DASHBOARD_TAG_2
      },
      {
        path: 'post',
        display: 1,
        role: ROLES.Page_Admin,
        title: 'common.article',
        permission: 'report_post',
        icon: 'ph ph-newspaper',
        url: uriConsts.report.DASHBOARD_POST,
      },
      {
        path: 'fbad',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_fbad',
        originTitle: 'Facebook Ads',
        icon: 'ph ph-megaphone',
        url: uriConsts.report.DASHBOARD_FBAD
      },
      {
        path: 'metacapi',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_metacapi',
        title: 'common.order.createOderToMeta', // tạo đơn hàng sang meta
        icon: 'ph ph-shopping-cart-simple',
        url: uriConsts.report.META_CAPI
      },
      {
        path: 'liveshopping/index',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_liveshopping',
        title: 'common.order.autoCreateOrder', // chốt đơn tự động
        icon: 'ph ph-video-camera',
        url: uriConsts.report.DASHBOARD_LIVESHOPPING
      },
      {
        path: 'livestreams/index',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_livestreams',
        originTitle: 'Live Streams',
        icon: 'ph ph-broadcast',
        url: uriConsts.report.DASHBOARD_LIVESTREAMS
      },
      {
        path: 'metabiz/index',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report',
        title: 'report.metabiz.title',
        icon: 'ph ph-robot',
        url: uriConsts.feature.METABIZ_REPORT
      },
    ]
  },
  {
    path: 'admin',
    display: 2,
    role: ROLES.Blog_Editor,
    permission: 'system',
    title: 'common.system', // hệ thống
    icon: 'ph ph-database',
    children: [
      {
        path: 'pages',
        display: 1,
        role: ROLES.Admin,
        title: 'common.listPages', // Danh sách pages
        icon: 'ph ph-facebook-logo',
        url: uriConsts.sys.SYS_PAGES
      },
      {
        path: 'users',
        display: 1,
        role: ROLES.Admin,
        title: 'common.user.listUser', // Danh sách user
        icon: 'ph ph-user-gear',
        url: uriConsts.sys.SYS_USERS
      },
      {
        path: 'payment',
        display: 1,
        role: ROLES.Admin,
        title: 'common.order.transactionList', // danh sách giao dịch
        icon: 'ph ph-credit-card',
        url: uriConsts.sys.SYS_PAYMENT
      },
      {
        path: 'auditlog',
        display: 1,
        role: ROLES.Admin,
        title: 'feature.system.auditLogTitle', // Nhật ký thao tác
        icon: 'ph ph-clock-counter-clockwise',
        url: uriConsts.sys.SYS_AUDIT_LOG
      },
      {
        path: 'report-user',
        display: 1,
        role: ROLES.SuperAdmin,
        title: 'common.report.user', // báo cáo người dùng
        icon: 'ph ph-chart-line-up',
        url: uriConsts.sys.SYS_REPORT_USER
      },
      {
        path: 'report-page-conversation',
        display: 1,
        role: ROLES.SuperAdmin,
        title: 'common.report.conversation', // báo cáo hội thoại
        icon: 'ph ph-chat-circle-dots',
        url: uriConsts.sys.SYS_REPORT_PAGE_CONVERSATION
      },
      {
        path: 'report-fbevent',
        display: 1,
        role: ROLES.SuperAdmin,
        originTitle: 'FB event logs',
        icon: 'ph ph-chart-line-up',
        url: uriConsts.sys.SYS_REPORT_FBEVENT
      },
      {
        path: 'blogs',
        display: 1,
        role: ROLES.Blog_Editor,
        title: 'common.article', // bài viết
        icon: 'ph ph-newspaper',
        url: uriConsts.sys.SYS_BLOGS
      },
      {
        path: 'industrycategoryprompt',
        display: 1,
        role: ROLES.Admin,
        title: 'feature.system.aiPromptTitle',
        icon: 'ph ph-robot',
        url: '/admin/ai/industrycategoryprompt'
      },
      {
        path: 'author',
        display: 1,
        role: ROLES.Blog_Editor,
        title: 'common.article.author', // tác giả
        icon: 'ph ph-graduation-cap',
        url: uriConsts.sys.SYS_AUTHOR
      },
      {
        path: 'mobile-app',
        display: 0,
        role: ROLES.SuperAdmin,
        title: 'common.app.listMobileApp', // Danh sách mobile app
        icon: 'ph ph-device-mobile',
        url: uriConsts.sys.SYS_MOBILE_APP
      },
      {
        path: 'manual',
        display: 0,
        role: ROLES.Admin,
        title: 'common.article.instructionManual', // hướng dẫn sử dung
        icon: 'ph ph-book-open',
        url: uriConsts.sys.SYS_MANUAL
      },
      {
        path: 'banner',
        display: 1,
        role: ROLES.Blog_Editor,
        title: 'common.system.manageBanner',
        icon: 'ph ph-image',
        url: uriConsts.sys.SYS_BANNER
      },
      {
        path: 'report-fmm',
        display: 1,
        role: ROLES.Admin,
        title: 'common.system.reportFmm',
        icon: 'ph ph-chart-line-up',
        url: uriConsts.report.REPORT_FMM
      },
      {
        path: 'referralcode',
        display: 1,
        role: ROLES.Admin,
        title: 'report.referralCode',
        icon: 'ph ph-barcode',
        url: uriConsts.sys.SYS_REPORT_REFERRAL_CODE
      },
    ]
  }
]
